import * as PopoverPrimitive from '@radix-ui/react-popover';

export const PvPopoverTrigger = PopoverPrimitive.Trigger;
